import type { Ref } from 'react';
import { forwardRef } from 'react';

import { generateDataTestId } from '@/lib/tests';

import { ReactComponent as ChevronLeft } from '@/assets/icons/chevron-left.svg';
import { ReactComponent as ChevronRight } from '@/assets/icons/chevron-right.svg';

import * as GS from '../ImageCarousel.styles';

const MAPPING = {
  next: <ChevronRight />,
  prev: <ChevronLeft />,
};

type NavigationProps = { className?: string; type: 'next' | 'prev' };

export const Navigation = forwardRef(
  ({ className, type }: NavigationProps, ref: Ref<HTMLSpanElement>) => {
    return (
      <GS.Navigation
        className={className}
        data-test-id='Navigation'
        {...generateDataTestId('carousel', type)}
        ref={ref}
        type={type}
      >
        {MAPPING[type]}
      </GS.Navigation>
    );
  },
);

Navigation.displayName = 'Navigation';
